import { FC } from 'react'
import { observer } from 'mobx-react-lite'
import styled from '@emotion/styled'
import { Ante, Bet, Bonus } from '../BettingBox/styles'
import { BoxStore } from '../../stores/RussianPoker/Box.store'
import { ChipOnBAB } from '../BettingBox/ChipOnBAB'

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 100%;
  width: 60px;
  height: 100%;
  padding: 4px;
  border-radius: 6px 0 0 6px;
  border: 1px solid rgba(255, 255, 255, 0.1);
`
const ContainerInside = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
`

const Item = styled.div`
  display: flex;
  position: relative;
`

const StyledAnte = styled(Ante)`
  width: 100%;
  height: 100%;
  max-width: 30px;
`

const StyledBonus = styled(Bonus)`
  width: 100%;
  height: 100%;
  max-width: 30px;
`

const StyledBet = styled(Bet)`
  width: 100%;
  height: 100%;
  max-width: 30px;
`

const BetsDataViewSide: FC<{
  box: BoxStore
}> = observer(({ box }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { ante, bet, insurance, bonus } = box
  return (
    <Container>
      <ContainerInside>
        <Item>
          <StyledBonus />
          {bonus.amount > 0 && <ChipOnBAB amount={bonus.amount} />}
        </Item>
        <Item>
          <StyledAnte />
          {ante > 0 && <ChipOnBAB amount={ante} />}
        </Item>
        <Item>
          <StyledBet />
          {bet > 0 && <ChipOnBAB amount={bet} />}
        </Item>
      </ContainerInside>
    </Container>
  )
})

export default BetsDataViewSide
